<template>
  <v-col sm="12" class="overrideCol">
    <div class="">
      <GmapMap
        :options="{ streetViewControl: false }"
        ref="map"
        :center="{lat: 44.801545, lng:20.458796}"
        :zoom="7"
        :style="'height:60vh;' + style"
        @click="pickCoordinate($event, true)"
        > 
          <GmapMarker v-for="(marker, index) in adaptedDestinations"
            :key="index"
            :clickable="true"
            :draggable="true"
            :position="marker"
            :icon="`http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=${index + 1}|42c2f5|000000`"
            @dragend="onDragEnd(marker, $event)"
          >
          </GmapMarker>

           <gmap-custom-marker
            v-if="adaptedSource"
            :marker="adaptedSource"
          >
             <v-btn x-small fab color="orange" style="margin-top:-34px; margin-left:-5px; color:white">
                <v-icon>
                    mdi-car
                </v-icon>
            </v-btn>
          </gmap-custom-marker>

          <gmap-custom-marker
            v-if="adaptedEndPoint"
            :marker="adaptedEndPoint"
          >
             <v-btn x-small fab color="red" style="margin-top:-34px; margin-left:-5px; color:white">
                <v-icon>
                    mdi-car
                </v-icon>
            </v-btn>
          </gmap-custom-marker>

          <gmap-polyline v-for="(route, index) in routesAdapted" :key="'poly-' + index"
            v-if="route.visible" :path="route.path"
            :options="{ strokeColor: route.color, strokeWeight : 3 }">
          </gmap-polyline>

      </GmapMap>
    </div>
  </v-col>
</template> 

<script>
import { gmapApi } from 'vue2-google-maps'
import RouteOptimizationMixin from './RouteOptimizationMixin'
import GoogleMapMixin from '../googleMapMixin'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import store from '@/store/store'

export default {
  name: 'GoogleRouteOptimization',
  mixins: [RouteOptimizationMixin, GoogleMapMixin],
  components: { 'gmap-custom-marker': GmapCustomMarker },
  computed: {
    google: gmapApi,
    adaptedDestinations() {
      return this.destinations.map(x => {
        return {
          lat: x.latlng.lat,
          lng: x.latlng.lng
        }
      })
    },
    routesAdapted() {
      return this.routes
        ? this.routes.map(x => {
            return {
              color: x.color,
              visible: x.visible,
              width: x.width,
              path: x.coordinates.map(x => {
                return {
                  lat: x[0],
                  lng: x[1]
                }
              })
            }
          })
        : []
    },
    adaptedSource() {
      return this.source
        ? this.source.latlng.lat && this.source.latlng.lng
          ? this.source.latlng
          : undefined
        : undefined
    },
    adaptedEndPoint() {
        return this.endPoint
                ? this.endPoint.latlng.lat && this.endPoint.latlng.lng
                  ? this.endPoint.latlng
                  : undefined
                : undefined
    }
  },
  methods: {
    onDragEnd(old, e) {
      store.dispatch('optimization/moveMarker', {
        new: {
          lat: e.latLng.lat(),
          lng: e.latLng.lng()
        },
        old: old
      })
    }
  },
  watch: {
    routes: {
      handler() {
        let routesToZoomIn = []
        for (const route of this.routesAdapted) {
          routesToZoomIn = routesToZoomIn.concat(route.path)
        }
        if (routesToZoomIn.length) {
          this.fitBounds(routesToZoomIn)
        }
      }
    },
    selectedRoute: {
      handler() {
        if (this.selectedRoute && this.selectedRoute.length) {
          this.fitBounds(
            this.selectedRoute.map(x => {
              return {
                lat: x[0],
                lng: x[1]
              }
            })
          )
        } else {
          let routesToZoomIn = []
          for (const route of this.routesAdapted) {
            routesToZoomIn = routesToZoomIn.concat(route.path)
          }
          if (routesToZoomIn.length) {
            this.fitBounds(routesToZoomIn)
          }
        }
      }
    }
  }
}
</script>

<style>
</style>
